
import { Box, Divider } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useFormContext, Controller } from "react-hook-form";
import { useTranslate } from "src/locales";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import ByzMuiRadioButton from "src/components/core-components/mui/buttons/ByzMuiRadioButton";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import ByzTitleAndInputBox from "src/components/core-components/ByzTitleAndInputBox/ByzTitleAndInputBox";

export const DischargeSection = () => {
  const { t } = useTranslate();
  const { control } = useFormContext();

  return (
    <Box
      sx={{
        border: "1px solid #DBDBDB",
        borderRadius: "4px",
        padding: "20px",
        width: "100%",
      }}
    >
      <Grid
        sx={{
          backgroundColor: "#63B4FF33",
          color: "#2979C3",
          borderRadius: "10px",
        }}
      >
        <ByzMuiTypography isTitle paddingRight={"20px"} paddingTop={"5px"}>
          {t("child-patient-assessment.patient-requests-and-discharge-info")}
        </ByzMuiTypography>
      </Grid>

      <Grid container spacing={2} pt={2}>
        {[
          { name: "dischargeInfo.method", label: "child-patient-assessment.discharge-method", desc: "dischargeInfo.methodDescription" },
          { name: "dischargeInfo.howWillGo", label: "child-patient-assessment.how-will-go", desc: "dischargeInfo.howWillGoDescription" },
          { name: "dischargeInfo.destination", label: "child-patient-assessment.destination", desc: "dischargeInfo.destinationDescription" },
        ].map((item) => (
          <Grid key={item.name} md={2} xs={6}>
            <ByzTitleAndInputBox marginLeft="0px" title={t(item.label)}>
              <Controller
                name={item.name}
                control={control}
                render={({ field }) => (
                  <ByzMuiSelect
                    {...field}
                    options={[]}
                    label={t("open-process-menu.select", "capitalize")}
                    sx={{ pt: 1 }}
                  />
                )}
              />
              <ByzTitleAndInputBox
                marginLeft="0px"
                sx={{ marginTop: "8px" }}
                title={t("description", "capitalize")}
              >
                <Controller
                  name={item.desc}
                  control={control}
                  render={({ field }) => (
                    <ByzMuiTextField {...field} multiline rows={2} sx={{ pt: 1 }} />
                  )}
                />
              </ByzTitleAndInputBox>
            </ByzTitleAndInputBox>
          </Grid>
        ))}

        <Grid md={3} xs={6}>
          <Grid container direction="row" alignItems="center">
            <Grid md={2}>
              <Controller
                name="dischargeInfo.homeCareNeeded"
                control={control}
                render={({ field }) => (
                  <ByzMuiCheckBox
                    {...field}
                    checked={!!field.value}
                    onChange={(e) => field.onChange(e.target.checked)}
                  />
                )}
              />
            </Grid>
            <Grid md={10}>
              <ByzMuiTypography>{t("child-patient-assessment.home-care-needed")}</ByzMuiTypography>
            </Grid>
          </Grid>
          <Controller
            name="dischargeInfo.homeCareDescription"
            control={control}
            render={({ field }) => (
              <ByzMuiTextField {...field} multiline rows={2} sx={{ pt: 1 }} />
            )}
          />
        </Grid>

        <Grid md={3} xs={6}>
          <Grid container direction="row" alignItems="center">
            <Grid md={2}>
              <Controller
                name="dischargeInfo.medicalEquipmentNeeded"
                control={control}
                render={({ field }) => (
                  <ByzMuiCheckBox
                    {...field}
                    checked={!!field.value}
                    onChange={(e) => field.onChange(e.target.checked)}
                  />
                )}
              />
            </Grid>
            <Grid md={10}>
              <ByzMuiTypography>{t("child-patient-assessment.medical-equipment-needed")}</ByzMuiTypography>
            </Grid>
          </Grid>
          <Controller
            name="dischargeInfo.medicalEquipmentDescription"
            control={control}
            render={({ field }) => (
              <ByzMuiTextField {...field} multiline rows={2} sx={{ pt: 1 }} />
            )}
          />
        </Grid>
      </Grid>

      <Divider sx={{ borderColor: "black", borderBottomWidth: "2px", my: 2 }} />

      <Grid container spacing={2}>
        <Grid md={2} xs={6}>
          <ByzTitleAndInputBox marginLeft="0px" title={t("child-patient-assessment.discharge-special-requirements")}>
            <Controller
              name="dischargeInfo.specialRequirements"
              control={control}
              render={({ field }) => (
                <ByzMuiTextField {...field} multiline rows={2} sx={{ pt: 1 }} />
              )}
            />
          </ByzTitleAndInputBox>
        </Grid>
        <Grid md={2} xs={6}>
          <ByzTitleAndInputBox marginLeft="0px" title={t("child-patient-assessment.mother-baby-bond")}>
            <Controller
              name="dischargeInfo.motherBabyBond"
              control={control}
              render={({ field }) => (
                <ByzMuiTextField {...field} multiline rows={2} sx={{ pt: 1 }} />
              )}
            />
          </ByzTitleAndInputBox>
        </Grid>
        <Grid md={3} xs={6}>
          <ByzTitleAndInputBox marginLeft="0px" title={t("child-patient-assessment.mother-working")}>
            <Controller
              name="dischargeInfo.motherWorking"
              control={control}
              render={({ field }) => (
                <ByzMuiRadioButton
                  {...field}
                  typographyText="yes,no,unknown"
                  layout="row"
                  border="none"
                  fontSize={16}
                />
              )}
            />
          </ByzTitleAndInputBox>
        </Grid>
      </Grid>
    </Box>
  );
};
